import { hasPermission } from "../../helpers/helpers"
import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit"

import { Button, Card, CardBody, Col, Row } from "reactstrap"
import axios from "axios"
import { API_URL } from "../../constants/constants"
import moment from "moment"
import { FiltersCard } from "./filter"
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import TableLoader from "components/Common/TableLoader"

//redux

const TabThree = props => {
  const selectRow = {
    mode: "checkbox",
  }

  const [data, setData] = useState([])
  const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"))
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"))
  const [tab, setTab] = useState(3)
  const [loading, setLoading] = useState(false)
  const { SearchBar } = Search

  const call = () => {
    setLoading(true)
    axios({
      method: "GET",
      url: `${API_URL}/admin/risk-per-user/${tab}?from=${fromDate}&to=${toDate}`,
    })
      .then(function (response) {
        setData(response?.data?.data)
        setLoading(false)
      })
      .catch(function (response) {})
  }

  useEffect(() => {
    setLoading(true)
    call()
  }, [tab])

  const dataColumn = [
    {
      dataField: "id",
      text: "Customer ID",
      sort: true,
    },
    {
      dataField: "phone_number",
      text: "Phone Number",
      sort: true,
    },
    {
      dataField: "created_at",
      text: "Date Of Joining",
      formatter: (cell, row) => {
        const date = new Date(row?.created_at)
        const formattedDate = date.toLocaleString("en-GB", {
          timeZone: "CAT",
          hour12: true,
        })
        const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
          match.toUpperCase()
        )
        return <>{capitalizedDate}</>
      },
      sort: true,
    },
    {
      dataField: "no_of_deposit",
      text: "No Of Deposit",
      sort: true,
    },
    {
      dataField: "total_deposit",
      text: "Total Deposit",
      sort: true,
    },
    {
      dataField: "cash_balance",
      text: "Cash Balance",
      sort: true,
    },
  ]

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]
  const { ExportCSVButton } = CSVExport
  //pagination customization
  const pageOptions = {
    sizePerPage: 30,
    totalSize: data?.length,
    custom: true,
  }

  return (
    <React.Fragment>
      <FiltersCard
        toDate={toDate}
        fromDate={fromDate}
        setFromDate={d => setFromDate(d)}
        setToDate={d => setToDate(d)}
        call={() => {
          call()
        }}
        todisplayToDate={true}
        hideShowType={false}
      />
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">
            {
              "Customers who have made more than 6 deposits over selected period."
            }
          </div>
          {loading ? (
            <TableLoader />
          ) : (
            <PaginationProvider
              pagination={paginationFactory(pageOptions)}
              keyField="id"
              columns={dataColumn}
              data={data}
            >
              {({ paginationProps, paginationTableProps }) => (
                <ToolkitProvider
                  keyField="id"
                  data={data}
                  columns={dataColumn}
                  bootstrap4
                  search
                  exportCSV={{
                    onlyExportFiltered: true,
                    exportAll: false,
                    fileName: `Third-Deposit-${moment(new Date()).format(
                      "DD/MM/YYYY"
                    )}.csv`,
                  }}
                >
                  {toolkitProps => (
                    <React.Fragment>
                      <Row className="mb-2">
                        <Col sm="6">
                          <Row>
                            <Col sm="12">
                              <div className="search-box me-2 mb-2 d-inline-block">
                                <div className="position-relative">
                                  <SearchBar {...toolkitProps.searchProps} />
                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col sm="6">
                          <div>
                            <ExportCSVButton
                              {...toolkitProps.csvProps}
                              className="download-table-xls-button w-md btn btn-primary"
                            >
                              Download
                            </ExportCSVButton>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xl="12">
                          <div className="table-responsive">
                            <BootstrapTable
                              keyField="id"
                              responsive
                              bordered={false}
                              striped={false}
                              defaultSorted={defaultSorted}
                              selectRow={selectRow}
                              classes={
                                "table align-middle table-nowrap table-check"
                              }
                              headerWrapperClasses={"table-light"}
                              {...toolkitProps.baseProps}
                              {...paginationTableProps}
                              rowClasses={"mytable-hover-row"}
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="pagination pagination-rounded justify-content-end">
                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              )}
            </PaginationProvider>
          )}
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default withRouter(TabThree)
